<template>
    <div class="d-flex flex-column setMaxWidthOfChildren align-items-center text-left mb-5 mt-2">
        <h3 class="my-2">{{ $t('activateuser.step1.header') }}</h3>
        <h5 class="my-2">{{ $t('activateuser.step1.subHeader') }}</h5>
        <p>
            {{ $t('activateuser.step1.description') }}
        </p>

        <SocialAuthBtns
            style="margin: 0 !important;"
            :redirectPath="redirectPath"
            :query-object="{ token: token }"
            :showAll="showAllSocialAuthButtons"
        />

        <BaseButton
            class="show-options-btn caption mute mt-3"
            :class="{ 'mt-5': showAllSocialAuthButtons }"
            tiny
            style="font-size:14px;display:block;margin:auto;"
            @click="toggleShowAllSocialAuthButtons"
        >
            {{
                showAllSocialAuthButtons
                    ? $t('shared.loginModule.logInPaper.hideAllOptions')
                    : $t('shared.loginModule.logInPaper.showAllOptions')
            }}
        </BaseButton>

        <h6 class="my-4 text-center">{{ $t('activateuser.step1.OR') }}</h6>

        <BaseButton @click="nextPage" variant="primary" class=" py-2">{{
            $t('activateuser.step1.emailAndPassword')
        }}</BaseButton>
    </div>
</template>

<script>
// Components
import Spinner from '~/components/builders/Spinner';
import SocialAuthBtns from '~/shared/loginmodule/components/SocialAuthBtns/SocialAuthBtns';

export default {
    name: 'Step1',
    components: {
        Spinner,
        SocialAuthBtns,
    },

    props: {
        redirectPath: String, // The redirect path for external providers]
        token: String,
    },
    data() {
        return {
            showAllSocialAuthButtons: false,
        };
    },
    methods: {
        nextPage() {
            this.$emit('nextpage');
        },
        toggleShowAllSocialAuthButtons() {
            this.showAllSocialAuthButtons = !this.showAllSocialAuthButtons;
        },
    },
};
</script>

<style scoped>
.animation-enter-active,
.animation-leave-active {
    transition: opacity 1s ease, transform 0.5s ease;
    opacity: 1;
    transform: translateX(0);
}
.animation-enter,
.animation-leave-to {
    transition: all 0.5s ease;
    opacity: 0;
}
.animation-enter {
    transform: translateX(50px);
}
.animation-leave-to {
    transform: translateX(-50px);
}
</style>
